import React, { useCallback, useEffect, useState } from "react";
import isArray from "lodash/isArray";
import { useDropzone } from "react-dropzone";
import { DefaultMark } from "components/icons";
import { Trash, File, Image } from "../../../entrypoints/dashboard/layouts/dashboard/sidebar/icons/icons/icons";
import { DotsIcon } from "../../../entrypoints/dashboard/icons";

import "./style.scss";

const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

const StarIcon = () => <svg width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill="var(--black6)" fillRule="evenodd" clipRule="evenodd" d="M7.99994 13.1463L4.09222 15.2008C3.62452 15.4466 3.04604 15.2668 2.80016 14.7991C2.70225 14.6129 2.66846 14.3996 2.70403 14.1922L3.45034 9.84086L0.288927 6.75925C-0.0894508 6.39042 -0.0971931 5.78469 0.271634 5.40632C0.418503 5.25564 0.610945 5.15759 0.819168 5.12733L5.18813 4.49249L7.14199 0.533537C7.37584 0.0597044 7.94953 -0.134839 8.42336 0.0990108C8.61204 0.192131 8.76477 0.344854 8.85789 0.533537L10.8117 4.49249L15.1807 5.12733C15.7036 5.20332 16.0659 5.68881 15.9899 6.21172C15.9597 6.41994 15.8616 6.61238 15.7109 6.75925L12.5495 9.84086L13.2958 14.1922C13.3852 14.713 13.0354 15.2076 12.5146 15.2969C12.3072 15.3324 12.0939 15.2987 11.9077 15.2008L7.99994 13.1463Z" />
</svg>;


const MultipleUpload = ({
                            label,
                            values,
                            mark,
                            default_image,
                            remove,
                            name,
                            isMulti,
                            type = 'image',
                            isBusiness,
                            setFieldValue,
                            disabled = false
                        }) => {

    const [warningMsg, setWarning] = useState("");
    const [local, setLocal] = useState(isArray(values[name]) ? values[name] : [values[name]]);


    useEffect(() => {
        setFieldValue(name, values[name]);
        setLocal(isArray(values[name]) ? values[name] : [values[name]]);
    }, [values[name]]);

	const onDrop = useCallback((accepted, rejected) => {

		if (Object.keys(rejected).length !== 0) {
			setWarning("Please submit valid file type");
		} else {

            if (accepted.length) {
                let updated = [];
                let fields = [];

                accepted.map((a) => {
                    updated.push(Object.assign(a, {
                        preview: URL.createObjectURL(a)
                    }));
                    fields.push(a);
                });

                setLocal([...updated, ...local]);
                setFieldValue(name, [...fields, ...values[name]]);
            } else {
                setFieldValue(name, []);
            }

            setWarning("");
        }

    }, [values[name]]);


    const markImage = (key) => {
        if ((values[name][key].uniqid || values[name][key].lastModified) && mark) {
            mark(values[name][key].uniqid || values[name][key].lastModified);
        }
    }

    const removeImage = (key) => {

        if (values[name][key].uniqid && remove) {
            remove(values[name][key].uniqid);
        }

        let newLocal = [...local];
        newLocal.splice(key, 1);

        let newFields = [...values[name]];
        newFields.splice(key, 1);

        setFieldValue(name, newFields);
        setLocal([...newLocal]);
    };

    const options = type === 'image' ? {
        accept: "image/*",
        disabled: disabled
    } : {};

    const {getRootProps, getInputProps} = useDropzone({
        onDrop: onDrop,
        multiple: isMulti,
        ...options
    });

    const thumbs = local.map((file, key) => {

        if (file) {

            let isDefault =
                default_image === file.uniqid ||
                default_image === file.lastModified ||
                (file.uniqid && (default_image && default_image.uniqid) === file.uniqid);

            if (type === "image") {

                return (
                    <aside key={key} className="multipe-uploader-thumb">
                        <div className="multipe-uploader-thumb-image">
                            {isDefault ? <div className="default-icon"><DefaultMark /></div> : null}
                            <img src={file.preview} alt={file.name}/>
                        </div>
                        <div className="multipe-uploader-thumb-info">
                            <div className="d-flex flex-column h-100 justify-content-around">
                                <span className="multipe-uploader-thumb-name">{file.name}</span>
                                <span className="multipe-uploader-thumb-size">
                                    {file.size ? formatBytes(file.size) : file.date ? file.size : ''}
                                </span>
                            </div>

                            {isMulti ?
                                <div className="paylixecommerce-table-actions">
                                    <DotsIcon />

                                    <div className="paylixecommerce-table-actions-modal">
                                        <div onClick={() => markImage(key)}>
                                            <StarIcon />
                                            <span>Set as Default</span>
                                        </div>
                                        <div className="delete-icon" onClick={() => removeImage(key)}>
                                            <Trash />
                                            <span>Delete</span>
                                        </div>
                                    </div>
                                </div>
                                :
                                <div>
                                    <div className="cursor-pointer" onClick={() => removeImage(key)}><Trash/></div>
                                </div>
                            }

                        </div>
                    </aside>
                )
            } else {
                return (
                    <aside key={key} className="multipe-uploader-thumb">
                        <div className="multipe-uploader-thumb-image">
                            <File/>
                        </div>
                        <div className="multipe-uploader-thumb-info">
                            <div className="d-flex flex-column h-100 justify-content-around">
                                <span className="multipe-uploader-thumb-name">{file.name}</span>
                                <span className="multipe-uploader-thumb-size">
                                    {file.size ? formatBytes(file.size) : file.date ? file.size : ''}
                                </span>
                            </div>
                            <div>
                                <div className="cursor-pointer" onClick={() => removeImage(key)}><Trash/></div>
                            </div>
                        </div>
                    </aside>
                )
            }
        } else {
            return <div key={key}/>
        }
    });

    const uploader = <div {...getRootProps()} className="multipe-uploader-area">
        <input {...getInputProps()} />
        {type === "image" ? <Image/> : <File/>}
        <div className="multipe-uploader-placeholder">
            <span>Click to Upload</span> or Drag n Drop {type === "file" ? "File" : 'Image'}
            <div>
                {type === 'image' ? `Files Supported: JPEG, PNG, Gif (max ${isBusiness ? 500 : 20} Mb)` : `Files Supported: ZIP, RAR, PDF and more (max ${isBusiness ? 500 : 20} Mb)`}
            </div>
        </div>
        <p className="multipe-uploader-warning">{warningMsg}</p>
    </div>;

    return (
        <div>
            {label ? <label className="paylixecommerce-label">{label}</label> : null}
            <div className={`multipe-uploader ${type !== "image" ? "file-uploader" : ""}`}>
                {values[name].length && !isMulti ? null : uploader}
                {thumbs}
            </div>
        </div>
    );

}

export default MultipleUpload;
